export const messages = {
  title: 'Schedule',
  today: 'Today',
  prevDay: 'Previous day',
  nextDay: 'Next day',
  prevWeek: 'Previous week',
  nextWeek: 'Next week',
  weekView: 'Week',
  dayView: 'Day',
  loading: 'Loading…',
  emptyDay: 'Nothing scheduled today',
  emptyDate: 'Nothing scheduled for this day',
  emptyWeek: 'Nothing scheduled this week',
  loadFailed: 'Failed to load',
  retry: 'Retry',
  categoryTimeline: 'Timeline',
  categoryWorkPlan: 'Work Plan',
  categoryTrainingPlan: 'Training Plan',
  categoryMealPlan: 'Meal Plan',
  categoryLearningPlan: 'Learning Plan',
  categoryLife: 'Life',
  typeTraining: 'Training',
  typeWork: 'Work',
  typeLearning: 'Learning',
  typeFixed: 'Fixed',
  typeDdl: 'DDL',
  typeMeal: 'Meal',
  distance: 'Distance',
  paceZone: 'Pace',
  heartRateZone: 'Heart rate',
  totalKcal: 'Total {kcal} kcal',
  kcal: '{kcal} kcal',
  mealNoDetails: 'No meal details yet',
  ddlDueToday: 'Due today',
  ddlDaysLeft: '{n}d left',
  ddlOverdue: '{n}d overdue',
  remindBefore: 'Remind 1 day before',
  note: 'Note',
  itemsCount: '{count} items',
  weekItemsCount: '{count} items',
  back: 'Back',
  heldTasks: 'Held',
  noHeldTasks: 'No held tasks',
  blockedTasks: 'Blocked',
  noBlockedTasks: 'No blocked tasks',
  inProgressTasks: 'In Progress',
  noInProgressTasks: 'No in-progress tasks',
  pendingTasks: 'Not Started',
  noPendingTasks: 'No pending tasks',
  overdueTasks: 'Overdue',
  noOverdueTasks: 'No overdue tasks',
  heldFor: 'Held for {days} days',
  restore: 'Restore',
  cancel: 'Cancel',
  viewHeldTasks: 'View held tasks',
  rangeSpan: '{from}–{to} · {n} days',
  rangeDayProgress: 'Day {k}/{n}',
  rangeLastDay: 'Last day'
} as const
